
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sleep",
      function () {
        return require("private-next-pages/sleep/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sleep"])
      });
    }
  